import { render, staticRenderFns } from "./WebsocketEventModal.vue?vue&type=template&id=36a4eac6&scoped=true"
import script from "./WebsocketEventModal.vue?vue&type=script&lang=js"
export * from "./WebsocketEventModal.vue?vue&type=script&lang=js"
import style0 from "./WebsocketEventModal.vue?vue&type=style&index=0&id=36a4eac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a4eac6",
  null
  
)

export default component.exports